<template>
    <div
        v-if="showFallback"
        class="certificate-fallback"
    >
        <img
            src="/images/certificates/1 - Horizontal Light/PNG/ISO 27001-2022-h-light.png"
            alt="ISO 27001:2022 Certificate"
            class="fallback-certificate-image"
        >
    </div>
    <div
        v-else
        id="demo"
        class="certificatebyqms"
        :data-apiKey="apiKey"
        data-isGreyBadge="false"
    >
    </div>
</template>

<script>
export default {
    name: 'QmsCertificate',
    data() {
        return {
            isMounted: false,
            isoCertificateScript: null,
            showFallback: false,
            observer: null,
            intervalId: null,
        };
    },
    computed: {
        apiKey() {
            return 'CGhSSaJ0WrjySkwVG15T/A7TyzB4EReZfG1KHc33cIKTg2h91wSP3Go7eCC3O3KSHMmWfvdQWsWmMOVS1qRA8ntCQzk2MEZDNy1DRDI3LTRFMDAtOEIzRC0xRkEwOEZFNzVCNTB9';
        },
    },
    methods: {
        getISOCertificate() {
            try {
                this.isoCertificateScript = document.createElement('script');
                this.isoCertificateScript.setAttribute('data-apiKey', this.apiKey);
                this.isoCertificateScript.setAttribute('src', 'https://qmsprodstorage.blob.core.windows.net/images/certificate-renderer.js');
                this.isoCertificateScript.onerror = () => {
                    this.showFallback = true;
                };
                if (this.isMounted) {
                    document.head.appendChild(this.isoCertificateScript);
                    this.startMonitoring();
                }
            } catch (error) {
                this.showFallback = true;
            }
        },
        startMonitoring() {
            const targetNode = document.getElementById('demo');
            if (!targetNode) {
                return;
            }

            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        this.checkForError();
                    }
                });
            });

            this.observer.observe(targetNode, {
                childList: true,
                subtree: true,
            });

            this.intervalId = setInterval(() => {
                this.checkForError();
            }, 1000);
        },
        checkForError() {
            const targetNode = document.getElementById('demo');
            if (!targetNode) {
                return;
            }

            const textContent = targetNode.textContent || targetNode.innerText || '';
            if (textContent.includes('No valid certificate available')) {
                this.showFallback = true;
                this.stopMonitoring();
            }
        },
        stopMonitoring() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
    },
    mounted() {
        this.isMounted = true;
        this.getISOCertificate();
    },
    beforeUnmount() {
        this.isMounted = false;
        this.stopMonitoring();
        if (this.isoCertificateScript) {
            document.head.removeChild(this.isoCertificateScript);
        }
    },
};
</script>

<style lang="scss">

.certificatebyqms {
    height: 112px;
    width: 195px;
}

.certificate-fallback {
    align-items: center;
    display: flex;
    height: 112px;
    justify-content: center;
    width: 195px;

    .fallback-certificate-image {
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }
}

.qmsuk-badge {
    img {
        height: 66px;
        width: 175px;
    }

    span {
        font-size: 11px !important;
    }
}

</style>